import CryptoJS from "crypto-js";
const Helper = {

    callApiAsJson: async (opt) => {
        let config = {
            method: opt.type,
            headers: {
                'Content-Type': 'application/json',
                "Authorization": 'bearer ' + localStorage.getItem('token')
            },
            //body: JSON.stringify(opt.data ?? {})
        };     
        if (opt.type != 'get' && opt.type != 'head') {
            config.body = JSON.stringify(opt.data ?? {});
        }

        return await fetch(opt.url, config)
            .then(data => {
                if (data.status == 401) {
                    window.location.replace("/login");
                }
                return data.json();
            })
            .catch((response) => {
                //console.log(response.status, response.statusText);
                //window.location.replace("/");
            });
    },

    //callApiAsFormData: async (opt) => {
    //    return await fetch(opt.url,
    //        {
    //            method: opt.type,
    //            headers: {
    //                "Authorization": 'bearer ' + localStorage.getItem('token')
    //            },
    //            "processData": false,
    //            "mimeType": "multipart/form-data",
    //            "contentType": false,
    //            body: opt.data
    //        })
    //        .then(data => {
    //            if (data.status == 401) {
    //                window.location.replace("/login");
    //            }
    //            return data.json();
    //        })
    //        .catch((response) => {
    //            //console.log(response.status, response.statusText);
    //            window.location.replace("/");
    //        });
    //},
    key:'8080808080808080',
    decode(str) {
        var key = CryptoJS.enc.Utf8.parse(this.key);
        var iv = CryptoJS.enc.Utf8.parse(this.key);

        var bytes = CryptoJS.AES.decrypt(str, key, {
            keySize: 128 / 8,
            iv: iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        });
        var obj = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
        return obj;
    }
    ,
    encorypt(obj) {
        var key = CryptoJS.enc.Utf8.parse(this.key);
        var iv = CryptoJS.enc.Utf8.parse(this.key);

        let text = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(JSON.stringify(obj)), key,{
            keySize: 128 / 8,
            iv: iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        }).toString();
        return text
    }
};

export default Helper; 